// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-block {
    color: red;
    font-size: small;
    line-height: 0;
}

::ng-deep .custom-dropdown .p-element.p-dropdown-item {
    width: 256px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/user/user.settings.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB","sourcesContent":[".help-block {\n    color: red;\n    font-size: small;\n    line-height: 0;\n}\n\n::ng-deep .custom-dropdown .p-element.p-dropdown-item {\n    width: 256px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
